import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import PaymentSuccessComponent from '../../Components/PaymentSuccessComponent/PaymentSuccessComponent'
import { GetLocalStorageParsed } from '../utils/page'


const PaymentSuccess = () => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>


        <Header setLoginToken={setLoginToken}/>
        <PaymentSuccessComponent />
        <Footer />
      </div>
    </>
  )
}

export default PaymentSuccess
